const AppConfigLocal = {
  "mapKey": "208e1c99aa440d8bc2847aafa3bc0669",
  "ngmApiDomain": "https://ngm-api.zzvvmm96.workers.dev",
  "name": "NextGenMap",
  "appDomain": "https://app.ngm.map.vn",
  "homePage": "https://ngm.map.vn",
  "sdkDomain": "https://api.ngm.map.vn",
  "environment": null
}
let AppConfig2 = AppConfigLocal
try {
  if (appSetting) {
    AppConfig2 = appSetting
  }
} catch (error) { }

export const AppConfig = AppConfig2
